<template>
    <div class="obras">
        <div class="container">
            <div class="row">
            <h2 class="text-center">Contacto</h2>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <p><span class="font-weight-bold"> Dirección:</span> Rca. Dominicana 997 esq. Amistad, 4to. Piso. Asunción, Paraguay.</p>
                    <p><span class="font-weight-bold">Teléfono:</span> +595 991 290 936</p>
                    <p><span class="font-weight-bold">Correo:</span> info@espais.com.py</p>
                </div>
                 <div class="col-md-6">
                           <div class="mapa">
                                <div class="resp-container">
                                    <iframe src="http://maps.google.com/maps?q=-25.2813818, -57.6047015&z=17&output=embed" frameborder="0" style="border:0" class="resp-iframe"></iframe>
                                </div>
                            </div>
                  </div>
            </div>

                <consultas class="mt-5"></consultas>
                <hr>



        </div>
    </div>
</template>

<script>

import Consultas from './Consultas.vue'

export default {
    components:{
         consultas: Consultas,
    }
}
</script>

<style>
.resp-container {
    position: relative;
    overflow: hidden;
    padding-top: 56.25%;
}
.resp-iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/contacto/Contacto.vue